<template>
  <div>
    <div class="welcome">修 改 密 码</div>
    <el-form
      ref="modifyPwdForm"
      class="modify-pwd-form"
      auto-complete="on"
      label-position="left"
    >
      <el-form-item prop="phone" class="login-form-item">
        <span class="svg-container">
          <i class="iconfont iconuser1"></i>
        </span>
        <el-input
          v-model="modifyPwdForm.phone"
          placeholder="手机号"
          type="text"
          tabindex="1"
          auto-complete="on"
        >
        </el-input>
      </el-form-item>
      <div>

      <el-form-item prop="smsCode" class="login-form-item">
        <span class="svg-container">
          <i class="iconfont iconyanzhengma"></i>
        </span>
        <el-input
          v-model="modifyPwdForm.smsCode"
          placeholder="验证码"
          type="text"
          tabindex="1"
          auto-complete="on"
        >
        </el-input>
        <el-button type="text" :disabled="duration>0" @click="getSmsCode">{{text}}</el-button>
      </el-form-item>
      </div>
      <el-form-item prop="password" class="login-form-item">
        <span class="svg-container">
          <i class="iconfont iconpassword"></i>
        </span>
        <el-input
          v-model="modifyPwdForm.password"
          placeholder="密码"
          type="text"
          tabindex="1"
          auto-complete="on"
        >
        </el-input>
      </el-form-item>
      <div>
            <el-button
              :loading="loading"
              type="primary"
              style="width:100%;"
              class="login-btn"
              @click="confirm"
              >确定</el-button
            >
          </div>
    </el-form>
  </div>
</template>

<script>
import {checkPhone} from '@/utils/tools.js'
export default {
  data() {
    return {
      modifyPwdForm: {
        password: "",
        phone: "",
        smsCode: "",
      },
      timer: null,
      duration: 0,
      text: '获取验证码',
      loading: false
    };
  },
  mounted() {

  },
  methods: {
    getSmsCode() {
      if (!checkPhone(this.modifyPwdForm.phone)) {       
        return false;
      }
      
      this.$api.sendSmsCode(this.modifyPwdForm.phone).then(res => {
        if (res.data.code === '200') {
          this.duration = 30
          this.countDown();
          this.$message({
            type: 'success',
            message: '发送成功'
          })
        } else {
          this.$message.error(res.data.msg);
        }
      })
    },
    // 倒计时
    countDown() {
      this.text = this.duration;
      this.timer = setTimeout(()=>{
        this.duration--;
        this.countDown();
      },1000)

      if(this.duration === 0){
        clearTimeout(this.timer)
        this.text = "获取验证码";
      }
    },
    // 确定
    confirm() {
      if (!checkPhone(this.modifyPwdForm.phone)) {       
        return false;
      }
      if (this.modifyPwdForm.smsCode === '') {
        this.$message.error('验证码不能为空');
        return;
      }
      if (this.modifyPwdForm.password === '') {
        this.$message.error('密码不能为空');
        return;
      }
      this.loading = true;
      
      this.$api.modifyPwd({
        password: this.modifyPwdForm.password,
        phone: this.modifyPwdForm.phone,
        smsCode: this.modifyPwdForm.smsCode
      }).then(res => {
        console.log(res);
        if (res.data.code === '200') {
          this.$message({
            type: 'success',
            message: '密码修改成功'
          })
        } else {
          this.$message.error(res.data.msg);
        }
      }).finally(() => {
        this.loading = false;
      })
    }
  },
  beforeDestroy() {
    clearTimeout(this.timer);
  }
};
</script>

<style lang="less" scoped>
.welcome {
  font-size: 30px;
  font-family: Source Han Sans CN;
  font-weight: bold;
  color: #1f8df2;
  text-align: center;
  margin: 40px 0;
}
.login-btn {
  height: 40px;
  background: #1F8DF2;
  border-radius: 20px;
  border: none;
}
</style>